import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useParams, useHistory, useRouteMatch } from "react-router-dom"
import { Button, Form, Input, Row, Col, notification } from "antd"
import { LeftOutlined } from "@ant-design/icons"
import nodePath from "path"

import { fetchFacilityType, selectFacilityType, setFacilityType, submitFacilityType } from "../facilityTypesSlice"

import { requestNotification } from "../../../../lib/notifications"

export default function FacilityTypeForm({ actionName }) {
    const { url } = useRouteMatch()
    const history = useHistory()
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const facilityType = useSelector(selectFacilityType)
    const { facilityTypeId } = useParams()

    useEffect(() => {
        if (facilityTypeId) {
            dispatch(fetchFacilityType(facilityTypeId))
        } else {
            dispatch(setFacilityType({}))
        }
    }, [dispatch, facilityTypeId])

    useEffect(() => {
        form.resetFields()
    }, [form, facilityType])

    const submit = async (values) => {
        const response = await dispatch(submitFacilityType(values, facilityTypeId))

        if (response.success) {
            actionName === "edit" ? history.push(`${nodePath.join(url, "../..")}`) : history.push(`${nodePath.join(url, "..")}`)
        }

        requestNotification(response)
    }

    return (
        <div id="user-form-container">
            <Link to={"/settings/facility_types"}>
                <LeftOutlined />
                Go Back
            </Link>
            <Form form={form} initialValues={facilityType} onFinish={submit} layout="vertical">
                <div className="card">
                    <div className="card-body">
                        <div>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}
